import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import queryString from 'query-string';

import ReturnTableList from '../../components/returns/ReturnTableList';
import Spinner from '../../components/generics/Spinner';
import ListHeader from '../../components/generics/ListHeader';
import Filter from '../../components/generics/Filter';
import _ from 'lodash';

import { STARTING_PAGE } from '../../constants/constants';

import {
  fetchReturns,
  fetchReturnsSuccess,
  fetchReturnsFailure,
  fetchDestinations,
  fetchDestinationsSuccess,
  fetchDestinationsFailure,
} from "../../store/shipments/actions";
import { withRouter } from "utils/WithRouter";

export class ReturnListContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      page: STARTING_PAGE,
      returnId: '',
      shipmentId: '',
      returnDate: '',
      customer: undefined
    }

    this.debounceSearch = _.debounce(this.filterList, 300);
  }

  componentDidMount(){
    const params = queryString.parse(this.props.location.search);
    const returnDate = params.date ? params.date : '';
    const returnId = params.return ? params.return : '';
    const shipmentId = params.shipment ? params.shipment : '';
    const customer = params.customer ? params.customer : undefined;
    const page = params.page ? params.page : STARTING_PAGE;
    this.setState({ page, returnId, shipmentId, returnDate, customer }, () => {
      this.props.fetchReturns(page, returnId, shipmentId, returnDate, customer);
    });
    if (this.props.destinationsList.destinations.length === 0){
      this.props.fetchDestinations();
    }
  }

  // ---------------------------------------------------------------------------
  // Filters
  // ---------------------------------------------------------------------------
  onDateChange = (event) => {
    let returnDate = event.target.value ? event.target.value : '';
    this.setState({ returnDate, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  onReturnIdChange = (event) => {
    let returnId = event.target ? event.target.value : '';
    this.setState({ returnId, page: STARTING_PAGE }, () => {
      this.debounceSearch();
    });
  };

  onShipmentIdChange = (event) => {
    let shipmentId = event.target ? event.target.value : '';
    this.setState({ shipmentId, page: STARTING_PAGE }, () => {
      this.debounceSearch();
    });
  };

  onCustomerChange = (event) => {
    let customer = event.target.value && event.target.value > -1 ? event.target.value : undefined;
    this.setState({ customer, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  };

  filterList = () => {
    let params = {};
    if (this.state.returnId){
      params.return = this.state.returnId;
    }
    if (this.state.shipmentId) {
      params.shipment = this.state.shipmentId;
    }
    if (this.state.returnDate){
      params.date = this.state.returnDate;
    }
    if (this.state.customer){
      params.customer = this.state.customer;
    }
    params.page = this.state.page;
    this.props.history.push({
      search: queryString.stringify(params)
    });
    this.props.fetchReturns(this.state.page,
                             this.state.returnId,
                             this.state.shipmentId,
                             this.state.returnDate,
                             this.state.customer);
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.filterList();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if(!this.props.returnList.returns){
      return(
        <Spinner />
      )
    }
    return (
      <div className="animated fadeIn">
        <div className="card">
          <ListHeader title="Returns"
                      iconClass="fa fa-arrow-circle-left mr-05"
                      actionLink={'/shipment'} />
          <Filter
            searchLabel="Return ID"
            searchPlaceholder="Return ID"
            searchVal={this.state.returnId}
            onSearchChange={this.onReturnIdChange}
            searchLabel2="Shipment ID"
            searchPlaceholder2="Shipment ID"
            searchVal2={this.state.shipmentId}
            onSearchChange2={this.onShipmentIdChange}
            dateLabel="Return Date"
            dateVal={this.state.returnDate}
            onDateChange={this.onDateChange}
            dropdownLabel="Customer"
            dropdownPlaceholder="Select customer"
            dropdownVal={this.state.customer}
            onDropdownChange={this.onCustomerChange}
            dropdownByElementId
            dropdownOptions={this.props.destinationsList.destinations}
            colClass="col-12 col-sm-3"
          />
        </div>
        <div className="card">
          <div className="card-block p-0">
            <ReturnTableList list={this.props.returnList.returns}  />

            {this.props.returnList.pages > 1 &&
              <ReactPaginate pageCount={this.props.returnList.pages}
                             pageRangeDisplayed={2}
                             marginPagesDisplayed={1}
                             previousLabel="<"
                             nextLabel=">"
                             onPageChange={this.handlePageRequest}
                             initialPage={this.state.page-1}
                             disableInitialCallback={true}
                             containerClassName="pagination"
                             pageClassName="page-item"
                             pageLinkClassName="page-link"
                             activeClassName="page-item active"
                             previousClassName="paginate_button previous"
                             nextClassName="paginate_button next"
                             disabledClassName="page-item disabled"
                             forcePage={this.state.page-1}/>
            }
          </div>
        </div>
        {this.props.returnList.loading ?
          <Spinner />
        :
          null
        }
      </div>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
    returnList: state.shipments.returnList,
    destinationsList: state.shipments.destinationsList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReturns: (page, returnId, shipmentId, returnDate, customer) => {
      dispatch(fetchReturns(page, returnId, shipmentId, returnDate, customer)).payload.then((response) => {
        dispatch(fetchReturnsSuccess(response.data))
      }, (error) => {
        dispatch(fetchReturnsFailure(error));
      });
    },
    fetchDestinations: (data) => {
      dispatch(fetchDestinations()).payload.then((response) => {
        dispatch(fetchDestinationsSuccess(response.data));
      }, (error) => {
        dispatch(fetchDestinationsFailure(error));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReturnListContainer));
